import { render } from "./PromotionTabVoucher.vue?vue&type=template&id=3299ba23"
import script from "./PromotionTabVoucher.vue?vue&type=script&lang=js"
export * from "./PromotionTabVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__